import { getOffsetTop, getElement, getElements } from '../utils/functional'

export default class ProductPage {
  constructor (el) {
    this.els = {
      el,
      prdDetails: getElement('.prd-Details-strip'),
      prdHero: getElement('.prd-Hero'),
      prdGallery: getElement('.sec-OurProducts')
    }

    window.onscroll = _ => {
      if (window.scrollY > this.els.prdHero.offsetHeight) {
        this.els.prdDetails.classList.add('prd-Details-asBar')
      } else {
        this.els.prdDetails.classList.remove('prd-Details-asBar')
      }

      if (window.scrollY > getOffsetTop(this.els.prdGallery)) {
        this.els.prdDetails.classList.add('prd-Details-asBarHidden')
      } else {
        this.els.prdDetails.classList.remove('prd-Details-asBarHidden')
      }
    }
  }
}
